// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2YxJS","col":"Table_col__1xAKE","fulfillmentStatus":"Table_fulfillmentStatus__CULNC","emailCol":"Table_emailCol__3cDIb"};